/**
 * DevExtreme (esm/core/utils/type.js)
 * Version: 24.2.6
 * Build date: Mon Mar 17 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export {
    isBoolean,
    isDate,
    isDeferred,
    isDefined,
    isEmptyObject,
    isEvent,
    isExponential,
    isFunction,
    isNumeric,
    isObject,
    isPlainObject,
    isPrimitive,
    isPromise,
    isRenderer,
    isString,
    isWindow,
    type
}
from "../../__internal/core/utils/m_type";
